import React from "react";
import { MdWarning } from "react-icons/md";

const ConfirmModal = ({
  isOpen,
  title = "¿Está seguro?",
  message = "Esta acción no se puede deshacer.",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  variant = "danger", // "danger" | "primary"
  loading = false,
  onConfirm,
  onClose,
}) => {
  if (!isOpen) return null;

  const buttonColors = {
    danger: "bg-red-600 hover:bg-red-700 text-white",
    primary: "bg-[#1D3B8B] hover:bg-[#152a66] text-white",
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-3xl max-w-sm w-full p-6 shadow-xl border border-gray-100 flex flex-col items-center text-center">
        <div
          className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 ${
            variant === "danger"
              ? "bg-red-50 text-red-600"
              : "bg-[#EEF2FF] text-[#1D3B8B]"
          }`}
        >
          <MdWarning size={26} />
        </div>

        <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
        {message && (
          <p className="text-sm text-gray-500 mb-6 leading-relaxed">
            {message}
          </p>
        )}

        <div className="flex w-full gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="flex-1 py-3 border border-gray-200 rounded-xl font-bold text-sm text-gray-600 hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 py-3 rounded-xl font-bold text-sm transition-colors shadow-md disabled:opacity-50 ${buttonColors[variant]}`}
          >
            {loading ? "Procesando..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
